import React, { useState } from "react";

import "./styles/MapFixed.scss";

import { useJsApiLoader } from "@react-google-maps/api";
import { Spinner } from "react-bootstrap";
import Map from "./Map";
import MapDirection from "./MapDirection";
import { MAP_API_KEY } from "../../config/config";

const MapFixed = ({
  location = {},
  hasMarker = false,
  route_id = undefined,
  isDirection = false,
  trip_type = "",
  direction = {},
  vehicle_location = null,
  isGestureHandling = false,
}) => {
  // const [libraries] = useState(["places", "marker"]);
  const [libraries] = useState(["places"]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MAP_API_KEY,
    libraries: libraries,
    // version: "beta",
  });

  return (
    <div className="mapFixed">
      {!isLoaded ? (
        <Spinner />
      ) : !isDirection ? (
        <Map
          location={location}
          setLatLng={() => {}}
          option={{ gestureHandling: isGestureHandling ? "auto" : "none" }}
          className="googleMap"
        />
      ) : direction.origin && direction.destination ? (
        <MapDirection
          trip_type={trip_type}
          hasMarker={hasMarker}
          route_id={route_id}
          origin={direction.origin}
          destination={direction.destination}
          waypoints={direction.waypoints}
          vehicle_location={vehicle_location}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default React.memo(MapFixed);
